import {aesDeciphering} from "../globalFunction";
import {setConfig, setResponse} from "./axiosConfigSetting";

const service = axios.create({
    timeout: 20000, // request timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
    crossDomain: true // 设置跨域为true
});

// request interceptor
service.interceptors.request.use(
    config => {
        const {method} = config;
        if (method === 'get') {
            config.headers['Content-Type'] = 'application/json; charset=utf-8';
        }
        if (method === 'post') {
            delete config['params'];
        }
        config = setConfig(config)
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
service.interceptors.response.use(
    response => {
        let res = response.data;
        if (res) {
            res = setResponse(response)
            // 数据解密
            if (res.data && Object.prototype.toString.call(res.data) === '[object Object]') {
                let nameArr = [
                    {encryptName: 'encrypt_phone', name: 'phone'},
                    {encryptName: 'encryptPhone', name: 'phone'},
                    {encryptName: 'encrypt_real_name', name: 'real_name'},
                    {encryptName: 'encryptRealName', name: 'realName'},
                    {encryptName: 'encrypt_address', name: 'address'},
                    {encryptName: 'encryptAddress', name: 'address'},
                ]
                nameArr.forEach(item => {
                    if (res.data[item.encryptName]) {
                        res.data[item.name] = aesDeciphering(res.data[item.encryptName]) + ''
                    }
                })
            }
            // 如果返回的参数需要加密，则进行解密
            if (response.config.hasAesDecipher) {
                // 兼容返回的res无data的情况
                if (typeof res === 'string') {
                    res = aesDeciphering(res);
                }else{
                    res.data = aesDeciphering(res.data);
                }
            }
            return res;
        } else {
            return res;
        }
    },
    error => {
        return Promise.reject(error);
    }
);
export default service;



// WEBPACK FOOTER //
// ./resources/js/config/axiosService.js